// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__IqlO-","Values":"About_Values__OfU28","Box":"About_Box__xI2LI"};